export const DoneLoadingIndicator = () => <div data-testid="doneLoadingSpinner" className="width-0 height-0" />;
